// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { AppDatabase } from './app-types';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error(
    'Missing Supabase environment variables. Set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY.'
  );
}

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<AppDatabase>(supabaseUrl, supabaseAnonKey, {
    auth: {
        persistSession: true
    }
});
